<template>
  <header class="header">
    <div class="wrapper">
      <div class="left">
        <router-link to="/" class="logo">
          <img src="./../assets/logo.svg" class="img" />
          <img src="./../assets/logo-mini.svg" class="img mob" />
        </router-link>
        <div class="select-container currency-select-container language-select-container">
          <Select2 v-if="currencies.length > 1" class="select2 single currency-select" v-model="curr" @select="selectCurrency($event)"  :options="currencies" :placeholder="curr" />
        </div>
        <div class="select-container language-select-container" v-if="currentLanguage">
          <Select2 v-if="languages.length > 1" class="select2 single currency-select" v-model="language" @select="selectLanguage($event)" :options="languages" :placeholder="currentLanguageName" />
        </div>
      </div>
      <ul class="nav">
        <template v-for="(item, i) in $parent.nav">
          <li class="nav__item" :key="i">
            <router-link :to="item.link">{{ $t(item.title) }}</router-link>
          </li>
        </template>
      </ul>
      <div class="right">
        <router-link to="/cart" v-if="$parent.isAuth" class="icon">
          <img src="./../assets/cart.svg" class="img" />
          <div v-if="cartContents.length" class="indicator">
            {{ cartContents.length }}
          </div>
        </router-link>
        <router-link to="/profile" class="button link-container dropdown-open" v-if="$parent.isAuth">
          <img src="./../assets/user.svg" class="img" />
        </router-link>
        <div class="link-container" v-else>
          <div class="button dark nav__item-signIn" @click="$parent.openSignInModal">
            <a>{{ $t("Sign in") }}</a>
          </div>
          <div class="button modal-open" @click="$parent.openSignUpModal">
            <span>{{ $t("Sign up") }}</span>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import Select2 from "vue3-select2-component";
import { mapState, mapMutations, mapGetters, mapActions } from "vuex";

export default {
  name: "Header",
  props: ["cartContents"],
  components: {
    Select2,
  },
  data: function () {
    return {
    };
  },
  computed: {
    ...mapState({
      languages: ({ app: { languages } }) => languages.map(({ id, title: text }) => ({ id, text })),
      currentLanguage: (state) => state.app.currentLanguage,
    }),
    ...mapState("app", ["currencies", "currency"]),
    ...mapGetters("app", ["currentLanguageName"]),
    language: {
      set(langId) {
        this.changeLocale(langId);
      },
      get() {
        return this.currentLanguage;
      },
    },
    curr: {
      set(currency) {
        this.setCurrency(currency)
      },
      get() {
        return this.currency;
      }
    }
  },
  watch: {
    currentLanguage() {
      if (this.$route.name === "TextPage") {
        this.$router.push({ path: "/" });
      }
    },
  },
  methods: {
    selectLanguage(event) {
      this.changeLocale(parseInt(event.id));
    },
    selectCurrency(event) {
      this.setCurrency(event.id);
    },
    openSignInModal() {
      this.$emit("openSignInModal");
    },
    openSaleSkinModal() {
      this.$emit("openSaleSkinModal");
    },
    logout() {
      this.$emit("logout");
    },
    ...mapMutations("app", ["setCurrentLanguage", 'setCurrency']),
    ...mapActions("app", ["changeLocale"]),
  },
};
</script>
